import React, { useEffect, useState } from 'react';
import IconBack from '../../assets/Images/icons/icon-back';
import { Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import IconCompanyScannerDefault from '../../assets/Images/icons/icon-scanner-import';
import { ExclamationCircleFilled } from '@ant-design/icons';
import CookieScannerService from '../../services/CookieScanner.service';
import GlobalService from '../../services/Global.service';
import { ROUTER } from '../../constants/router';
import moment from 'moment';

export default function CookieScannerReport() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { domainId } = useParams();
    const [report, setReport] = useState();
    const [imageUrl, setImageUrl] = useState();

    useEffect(() => {
        const getScannerReport = async () => {
            try {
                const { data } = await CookieScannerService.getScannerReport(
                    domainId
                );
                if (data?.resultData) {
                    console.log(data?.resultData);
                    getImage(data?.resultData?.screenshot);
                    await setReport(data?.resultData);
                }
            } catch (err) {
                console.log(err);
            }
        };
        getScannerReport();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const exportScanner = async (fileType) => {
        try {
            const { data } = await CookieScannerService.exportScanner(
                domainId,
                { fileType: fileType }
            );
            if (data) {
                const name = `Cookie_Scanner_Report_${moment(new Date()).format(
                    'YYYY-MM-DD'
                )}`;
                if (fileType === 'xlsx') {
                    let blob = new Blob([data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,',
                    });

                    let a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = `${name}.xlsx`;
                    a.click();
                }
                if (fileType === 'csv') {
                    const blob = new Blob([data]);
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveBlob(
                            blob,
                            'cookie-scanner-report.csv'
                        );
                    } else {
                        let reader = new FileReader();
                        reader.onload = function () {
                            const link = document.createElement('a');
                            let universalBOM = '\uFEFF';
                            link.setAttribute(
                                'href',
                                'data:text/csv; charset=utf-8,' +
                                    encodeURIComponent(
                                        universalBOM + reader.result
                                    )
                            );
                            link.setAttribute('download', `${name}.csv`);
                            document.body.appendChild(link);
                            link.click();
                            link.parentNode.removeChild(link);
                        };
                        reader.readAsText(data);
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getImage = async (id) => {
        try {
            const { data } = await GlobalService.getImage(id);
            if (data.resultData?.imageId) {
                setImageUrl(
                    `data:image/png;base64,${data.resultData?.imageId}`
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(-1);
                    }}
                >
                    <IconBack />
                </div>
                <span>{t('common.CookieScanner')}</span>
            </div>
            <div className="sub-title mb-2">
                <span className="text-sm text-gray-400">
                    {t('Cookie Management')} /
                </span>
                <span>{t('common.CookieScanner')}</span>
            </div>
            <div className="bg-white rounded-xl px-14 py-8 my-4 col-span-2">
                <div
                    className="flex justify-between mb-5 p-2"
                    style={{ borderBottom: '3px solid #F4F6FC' }}
                >
                    <div className="text-2xl font-semibold pb-2 text-purple">
                        {t('common.CookieScannerReport')}
                    </div>

                    <div className="space-x-3 font-sm items-right justify-end">
                        <div className="space-x-4 items-right mb-2 text-right">
                            <Button
                                size="large"
                                type="default"
                                className="text-purple-PHX border-purple-PHX w-32"
                                onClick={() => {
                                    exportScanner('xlsx');
                                }}
                            >
                                {t('COOKIE.ExportExcel')}
                            </Button>
                            <Button
                                size="large"
                                type="default"
                                className="text-purple-PHX border-purple-PHX w-32"
                                onClick={() => {
                                    exportScanner('csv');
                                }}
                            >
                                {t('COOKIE.ExportCSV')}
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="flex">
                    <div className="flex-none w-40"></div>
                    <div className="grow">
                        <div className="grid grid-cols-2 gap-6">
                            <div className="p-6 col-span-2 box-content">
                                <div className="grid grid-cols-2 gap-6">
                                    <div className="...">
                                        <div className="mb-2">
                                            <div className="flex item-center space-x-2">
                                                <span>
                                                    <svg
                                                        width="21"
                                                        height="22"
                                                        viewBox="0 0 19 18"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M15.5701 5.64809C15.4529 5.62463 15.365 5.6129 15.3064 5.6129C14.8728 5.6129 14.4978 5.75953 14.1814 6.05279C13.4666 5.73607 12.7986 5.47801 12.1775 5.27859C11.158 4.95015 10.0916 4.68035 8.97827 4.46921C8.8728 4.18768 8.7146 3.95308 8.50366 3.7654C8.79663 2.38123 9.18921 1.1261 9.6814 0C11.158 0.105572 12.5144 0.533724 13.7507 1.28446C14.9871 2.03519 15.9861 3.02053 16.7478 4.24047C16.3142 4.70968 15.9216 5.17889 15.5701 5.64809ZM7.41382 3.3607C7.10913 3.3607 6.82202 3.44282 6.55249 3.60704C5.60327 2.90323 4.64819 2.30499 3.68726 1.81232C5.14038 0.709677 6.76929 0.105572 8.57397 0C8.11694 1.02053 7.7478 2.14076 7.46655 3.3607H7.41382ZM1.31421 4.45161C1.71265 3.78299 2.21655 3.14956 2.82593 2.55132C3.6228 2.96188 4.44897 3.46628 5.30444 4.06452C3.79272 4.02933 2.46265 4.15836 1.31421 4.45161ZM5.72632 5.15543C5.74976 5.51906 5.87573 5.83871 6.10425 6.11437C6.33276 6.39003 6.61694 6.57478 6.95679 6.66862C6.88647 7.48974 6.85132 8.26979 6.85132 9.0088C6.85132 9.52493 6.8689 10.1173 6.90405 10.7859C6.64624 10.868 6.41772 11.0088 6.21851 11.2082C5.58569 10.9619 4.97632 10.6804 4.39038 10.3636C4.51929 10.1056 4.58374 9.84164 4.58374 9.57185C4.58374 9.10264 4.41968 8.70381 4.09155 8.37537C3.76343 8.04692 3.36499 7.8827 2.89624 7.8827C2.38062 7.8827 1.95288 8.08211 1.61304 8.48094C1.12085 8.03519 0.681396 7.57185 0.294678 7.09091C0.400146 6.58651 0.55835 6.08798 0.769287 5.59531C2.19897 5.19648 3.85132 5.04985 5.72632 5.15543ZM1.22632 9.71261C1.26147 10.1466 1.44019 10.5132 1.76245 10.8123C2.08472 11.1114 2.46265 11.261 2.89624 11.261C3.02515 11.261 3.16577 11.2375 3.31812 11.1906C4.06812 11.6246 4.87085 12 5.72632 12.3167V12.3871C5.72632 12.8446 5.88159 13.2346 6.19214 13.5572C6.50269 13.8798 6.88647 14.0528 7.34351 14.0762C7.63647 15.5073 8.04663 16.8152 8.57397 18C7.4021 17.9296 6.29468 17.6452 5.25171 17.1466C4.20874 16.6481 3.30933 16 2.55347 15.2023C1.79761 14.4047 1.19702 13.4663 0.751709 12.3871C0.306396 11.3079 0.0837402 10.1818 0.0837402 9.0088C0.0837402 8.99707 0.0895996 8.83871 0.101318 8.53372C0.429443 8.94428 0.804443 9.33724 1.22632 9.71261ZM8.89038 13.1789C9.73413 13.3314 10.5837 13.4311 11.4392 13.478C11.5212 13.7126 11.6501 13.9296 11.8259 14.129C11.5564 15.3607 11.3923 16.5572 11.3337 17.7185C10.7361 17.871 10.1853 17.9648 9.6814 18C9.13062 16.7449 8.70288 15.3255 8.39819 13.7419C8.60913 13.6012 8.77319 13.4135 8.89038 13.1789ZM14.3396 14.0235C14.4919 13.8358 14.5974 13.6364 14.656 13.4252C15.5115 13.3548 16.3376 13.2434 17.1345 13.0909C16.572 14.1935 15.7986 15.1496 14.8142 15.9589C14.7087 15.349 14.5505 14.7038 14.3396 14.0235ZM11.4744 12.3519C10.6541 12.305 9.84546 12.1994 9.04858 12.0352C8.91968 11.4487 8.58569 11.044 8.04663 10.8211C7.99976 10.129 7.97632 9.52493 7.97632 9.0088C7.97632 8.2346 8.01147 7.43109 8.08179 6.59824C8.10522 6.59824 8.13452 6.58651 8.16968 6.56305C8.20483 6.53959 8.22827 6.52786 8.23999 6.52786C8.69702 6.97361 9.09546 7.38416 9.4353 7.75953C10.4548 8.88563 11.322 10.1642 12.0369 11.5953C11.7791 11.7947 11.5916 12.0469 11.4744 12.3519ZM13.0388 14.6393C13.0623 14.6393 13.1267 14.6334 13.2322 14.6217C13.4314 15.3372 13.5779 16.0469 13.6716 16.7507C13.3318 16.9501 12.9216 17.1496 12.4412 17.349C12.5232 16.434 12.6638 15.5249 12.863 14.6217C12.9568 14.6334 13.0154 14.6393 13.0388 14.6393ZM12.9509 10.434C12.9392 10.4575 12.9246 10.4927 12.907 10.5396C12.8894 10.5865 12.8748 10.6217 12.863 10.6452C12.1248 9.30792 11.2576 8.09384 10.2615 7.00293C9.89819 6.59238 9.4646 6.14663 8.96069 5.66569C8.97241 5.66569 8.9812 5.65689 8.98706 5.6393L8.99585 5.6129C9.98022 5.81232 10.9236 6.05865 11.8259 6.35191C12.3767 6.52786 12.9802 6.76246 13.6365 7.05572C13.613 7.17302 13.6013 7.261 13.6013 7.31965C13.6013 7.67155 13.7068 7.99413 13.9177 8.28739C13.531 9.02639 13.2087 9.74194 12.9509 10.434ZM13.7771 11.4545C13.9177 11.044 13.988 10.8328 13.988 10.8211C14.2224 10.2346 14.5154 9.60704 14.8669 8.93842C15.0193 8.98534 15.1658 9.0088 15.3064 9.0088C15.7048 9.0088 16.0623 8.8739 16.3787 8.60411C16.9529 9.00293 17.5154 9.44868 18.0662 9.94135C17.9958 10.61 17.8552 11.2551 17.6443 11.8768C16.6833 12.0762 15.6697 12.217 14.6033 12.2991C14.4509 11.9238 14.1755 11.6422 13.7771 11.4545ZM16.9939 7.30205C16.9939 6.91496 16.865 6.56305 16.6072 6.24633C16.8533 5.92962 17.0994 5.64223 17.3455 5.38416C17.7673 6.34604 18.0134 7.33724 18.0837 8.35777C17.697 8.06452 17.322 7.80059 16.9587 7.56598C16.9822 7.46041 16.9939 7.37243 16.9939 7.30205Z"
                                                            fill="#7B67FB"
                                                        />
                                                    </svg>
                                                </span>
                                                <span className="font-semibold text-[16px]">
                                                    {report?.url || '-'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="relative text-center bg-[#ffffff] w-full scale-100 rounded-md">
                                            {imageUrl ? (
                                                <img
                                                    className="w-full h-full"
                                                    src={imageUrl}
                                                    alt="avatar"
                                                />
                                            ) : (
                                                <div className="py-10 w-full h-full">
                                                    <IconCompanyScannerDefault />
                                                </div>
                                            )}

                                            {/* </div> */}
                                        </div>
                                    </div>
                                    <div className="...">
                                        <div className="mb-2">
                                            <div className="flex item-center space-x-2">
                                                <span>
                                                    <svg
                                                        width="21"
                                                        height="22"
                                                        viewBox="0 0 21 22"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M17.2617 1.54545H15.7711C15.5864 1.09335 15.2442 0.701961 14.7918 0.425185C14.3395 0.148409 13.7991 -0.000138263 13.2451 9.65644e-08H7.88965C7.3357 -0.000138263 6.79533 0.148409 6.34295 0.425185C5.89057 0.701961 5.54843 1.09335 5.36366 1.54545H3.87305C3.04451 1.54545 2.2499 1.8304 1.66403 2.3376C1.07816 2.8448 0.749023 3.53271 0.749023 4.25V18.9318C0.749023 19.6491 1.07816 20.337 1.66403 20.8442C2.2499 21.3514 3.04451 21.6364 3.87305 21.6364H17.2617C18.0903 21.6364 18.8849 21.3514 19.4708 20.8442C20.0566 20.337 20.3858 19.6491 20.3858 18.9318V4.25C20.3858 3.53271 20.0566 2.8448 19.4708 2.3376C18.8849 1.8304 18.0903 1.54545 17.2617 1.54545ZM7.88965 1.54545H13.2451C13.4819 1.54545 13.7089 1.62687 13.8763 1.77178C14.0437 1.9167 14.1377 2.11324 14.1377 2.31818C14.1377 2.52312 14.0437 2.71967 13.8763 2.86458C13.7089 3.0095 13.4819 3.09091 13.2451 3.09091H7.88965C7.65293 3.09091 7.4259 3.0095 7.25851 2.86458C7.09111 2.71967 6.99708 2.52312 6.99708 2.31818C6.99708 2.11324 7.09111 1.9167 7.25851 1.77178C7.4259 1.62687 7.65293 1.54545 7.88965 1.54545ZM5.65821 7.72727C6.0133 7.72727 6.35384 7.84939 6.60493 8.06676C6.85602 8.28413 6.99708 8.57895 6.99708 8.88636V15.8409C6.99708 16.1483 6.85602 16.4431 6.60493 16.6605C6.35384 16.8779 6.0133 17 5.65821 17C5.30312 17 4.96257 16.8779 4.71148 16.6605C4.4604 16.4431 4.31934 16.1483 4.31934 15.8409V8.88636C4.31934 8.57895 4.4604 8.28413 4.71148 8.06676C4.96257 7.84939 5.30312 7.72727 5.65821 7.72727ZM9.22852 10.4318C9.22852 10.1244 9.36958 9.82959 9.62067 9.61222C9.87175 9.39484 10.2123 9.27273 10.5674 9.27273C10.9225 9.27273 11.263 9.39484 11.5141 9.61222C11.7652 9.82959 11.9063 10.1244 11.9063 10.4318V15.8409C11.9063 16.1483 11.7652 16.4431 11.5141 16.6605C11.263 16.8779 10.9225 17 10.5674 17C10.2123 17 9.87175 16.8779 9.62067 16.6605C9.36958 16.4431 9.22852 16.1483 9.22852 15.8409V10.4318ZM15.4766 12.3636C15.8317 12.3636 16.1722 12.4858 16.4233 12.7031C16.6744 12.9205 16.8154 13.2153 16.8154 13.5227V15.8409C16.8154 16.1483 16.6744 16.4431 16.4233 16.6605C16.1722 16.8779 15.8317 17 15.4766 17C15.1215 17 14.7809 16.8779 14.5299 16.6605C14.2788 16.4431 14.1377 16.1483 14.1377 15.8409V13.5227C14.1377 13.2153 14.2788 12.9205 14.5299 12.7031C14.7809 12.4858 15.1215 12.3636 15.4766 12.3636Z"
                                                            fill="#7B67FB"
                                                        />
                                                    </svg>
                                                </span>
                                                <span className="font-semibold text-[16px]">
                                                    {t('COOKIE.Summary')}
                                                </span>
                                            </div>
                                            <div className="text-[12px] text-[#65707A] pl-5">
                                                &#8226; {t('COOKIE.ScanDate')}:{' '}
                                                {report?.scanDate || '-'}
                                            </div>
                                            <div className="text-[12px] text-[#65707A] pl-5">
                                                &#8226; {t('COOKIE.DomainName')}
                                                : {report?.domainName || '-'}
                                            </div>
                                            <div className="text-[12px] text-[#65707A] pl-5">
                                                {t('Total')}:{' '}
                                                {report?.total || '-'}
                                            </div>
                                        </div>
                                        <div className="mb-2">
                                            <div className="flex item-center space-x-2">
                                                <span>
                                                    <svg
                                                        width="21"
                                                        height="22"
                                                        viewBox="0 0 21 22"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M19.7529 2.98203L10.5536 0.267969C10.4426 0.235156 10.2937 0.21875 10.1448 0.21875C9.99593 0.21875 9.84703 0.235156 9.73603 0.267969L0.536728 2.98203C0.312024 3.04766 0.12793 3.27266 0.12793 3.47891V14.7852C0.12793 14.9914 0.282244 15.2633 0.469046 15.3922L9.80101 21.6875C9.89576 21.7508 10.0176 21.7836 10.1421 21.7836C10.2667 21.7836 10.3912 21.7508 10.4832 21.6875L19.8152 15.3922C20.002 15.2656 20.1563 14.9937 20.1563 14.7852V3.47891C20.1617 3.27266 19.9776 3.05 19.7529 2.98203ZM13.2528 11.9844C11.9398 13.1211 9.92283 13.2781 8.41759 12.4555L6.31946 14.2719C6.27875 14.3068 6.22378 14.3263 6.1665 14.3263C6.10921 14.3263 6.05424 14.3068 6.01354 14.2719L5.09306 13.475C5.05276 13.4398 5.03015 13.3922 5.03015 13.3426C5.03015 13.293 5.05276 13.2454 5.09306 13.2102L7.1912 11.3937C6.24095 10.0883 6.42233 8.34453 7.73536 7.20781C9.25955 5.88828 11.7286 5.88828 13.2528 7.20781C14.777 8.52734 14.777 10.6648 13.2528 11.9844ZM8.96067 10.9234C9.16146 11.0999 9.40064 11.2403 9.66442 11.3365C9.9282 11.4327 10.2114 11.4827 10.4976 11.4836C10.7838 11.4846 11.0674 11.4365 11.332 11.3421C11.5966 11.2477 11.8371 11.1089 12.0394 10.9337C12.2418 10.7585 12.4021 10.5504 12.5111 10.3212C12.6201 10.0921 12.6756 9.84661 12.6745 9.59883C12.6734 9.35106 12.6156 9.10593 12.5045 8.87758C12.3934 8.64923 12.2312 8.44217 12.0272 8.26836C11.8264 8.09179 11.5872 7.95137 11.3234 7.85521C11.0597 7.75905 10.7765 7.70905 10.4903 7.70809C10.2041 7.70712 9.9205 7.75522 9.65586 7.8496C9.39123 7.94398 9.15079 8.08278 8.94842 8.25799C8.74605 8.4332 8.58574 8.64137 8.47675 8.87048C8.36775 9.09958 8.31222 9.34511 8.31336 9.59288C8.3145 9.84066 8.37228 10.0858 8.48338 10.3141C8.59448 10.5425 8.75669 10.7495 8.96067 10.9234Z"
                                                            fill="#7B67FB"
                                                        />
                                                    </svg>
                                                </span>
                                                <span className="font-semibold text-[16px]">
                                                    {t('COOKIE.ScanResult')}
                                                </span>
                                            </div>
                                            <div className="text-[12px] text-[#65707A] pl-5">
                                                &#8226;{' '}
                                                {report?.identified || '-'}{' '}
                                            </div>
                                            <div className="text-[12px] text-[#65707A] pl-5">
                                                &#8226;{' '}
                                                {report?.unidentified || '-'}{' '}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {report?.cookieCategory?.map((item) => (
                                <>
                                    {item?.count > 0 ? (
                                        <div className="p-6 box-content">
                                            <div className="grid grid-cols-4 gap-4">
                                                <div className="...">
                                                    <div className="flex flex-col">
                                                        <div>
                                                            <svg
                                                                width="22"
                                                                height="20"
                                                                viewBox="0 0 22 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M0.5 19.6574L14.0882 19.6714C14.9159 19.6714 15.6571 19.2077 16.1018 18.4911L21.5 9.83571L16.1018 1.18029C15.6571 0.463684 14.9159 0 14.0882 0L0.5 0.0140513L6.47882 9.83571L0.5 19.6574Z"
                                                                    fill="#7B67FB"
                                                                />
                                                            </svg>
                                                        </div>
                                                        <div className="font-semibold text-[32px]">
                                                            {item?.count || 0}
                                                        </div>
                                                        <div className="font-semibold text-[12px]">
                                                            {item?.cookieCategoryGroup ||
                                                                '-'}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-span-3 text-[12px] font-base">
                                                    <div className="">
                                                        {item?.detail || '-'}
                                                    </div>
                                                </div>
                                                <div
                                                    className="col-span-4"
                                                    style={{
                                                        borderTop:
                                                            '3px solid #D9DDFF',
                                                    }}
                                                >
                                                    <div className="flex justify-between mt-5">
                                                        {item?.cookieCategoryGroup ===
                                                        'Unclassified' ? (
                                                            <div className="font-semibold text-[12] text-[#F0536F] ">
                                                                <span className="mr-2">
                                                                    <ExclamationCircleFilled />
                                                                </span>
                                                                {t(
                                                                    'COOKIE.PleaseDefineCookieCategory'
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div className="font-semibold text-[12] text-[#95A0A8]">
                                                                {t(
                                                                    'COOKIE.ViewDetail'
                                                                )}
                                                            </div>
                                                        )}
                                                        <div>
                                                            <Button
                                                                size="large"
                                                                type="primary"
                                                                className="text-white border-purple-PHX w-18"
                                                                onClick={() => {
                                                                    navigate(
                                                                        `${ROUTER.COOKIE_MANAGEMENT.COOKIE_SCANNER}/report/${domainId}/${item?.cookieCategoryGroup}`
                                                                    );
                                                                }}
                                                            >
                                                                {nextIcon}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </>
                            ))}
                        </div>
                    </div>
                    <div className="flex-none w-40"></div>
                </div>
            </div>
        </>
    );
}
const nextIcon = (
    <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_8814_31957)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.61 9.97162C4.06327 10.5184 4.06327 11.4048 4.61 11.9515C5.15674 12.4983 6.04317 12.4983 6.5899 11.9515L10.5497 7.99172C10.6939 7.84755 10.8 7.67975 10.8682 7.50079C11.0585 7.00107 10.9523 6.41429 10.5497 6.01169L6.58995 2.0519C6.04321 1.50516 5.15678 1.50516 4.61005 2.0519C4.06331 2.59863 4.06332 3.48506 4.61005 4.0318L7.57994 7.00168L4.61 9.97162Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_8814_31957">
                <rect
                    width="14"
                    height="12.6"
                    fill="white"
                    transform="translate(12.8) rotate(90)"
                />
            </clipPath>
        </defs>
    </svg>
);
